var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "liquidez-chart az-card-bordered",
      class: { "liquidez-chart--loading": _vm.loading }
    },
    [
      !_vm.loading
        ? _c("div", { staticClass: "liquidez-chart__title az-ds-card-title" }, [
            _vm._v(" " + _vm._s(_vm.title) + " ")
          ])
        : _vm._e(),
      _c(
        "FeedbackWrapper",
        {
          attrs: {
            loading: _vm.loading,
            noData: !_vm.processedData.labels.length,
            message: _vm.emptyMessage,
            minHeight: _vm.minHeight
          }
        },
        [
          _c("div", { staticClass: "liquidez-chart__content" }, [
            _c(
              "div",
              { staticClass: "liquidez-chart__graph" },
              [
                _c("donut-chart", {
                  attrs: {
                    chartData: _vm.chartConfig.data,
                    options: _vm.chartConfig.options,
                    width: _vm.isSmall ? 150 : 375,
                    height: _vm.isSmall ? 150 : 250
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "liquidez-chart__legends" },
              _vm._l(_vm.legends, function(legend, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "liquidez-chart__legend" },
                  [
                    _c("div", {
                      staticClass: "liquidez-chart__legend-color",
                      style: { backgroundColor: legend.color }
                    }),
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "span",
                                    _vm._g(
                                      {
                                        staticClass:
                                          "liquidez-chart__legend-label"
                                      },
                                      on
                                    ),
                                    [_vm._v(" " + _vm._s(legend.label) + " ")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.formatTooltip(legend)))])]
                    )
                  ],
                  1
                )
              }),
              0
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }